let selectedRows = new Set();
const UPDATED_AFTER_LOCK_ENTITY_COLUMNS = {
  base_salary: [3, 4, 5],
  additional_allowances: [7],
  one_time_allowance: [8],
  deductions: [9],
  claims: [10],
  leaves: [11],
};

document.addEventListener("DOMContentLoaded", () => {
  if (window.location.pathname == "/final_settlements") {
    renderFinalSettlementSheet();
    $("#final-settlement-salary-month").select2();
    $("#final-settlement-sheet_filter").find("input")[0].type = "text";
    $("#select_final_settlement_month").datetimepicker({
      format: window.MONTH_YEAR_FORMAT,
      viewMode: "months",
      date: moment($("#select_final_settlement_month").data("default")),
      maxDate: moment($("#select_final_settlement_month").data("max-month")),
      minDate: moment($("#select_final_settlement_month").data("min-month")),
      icons: {
        previous: "fas fa-chevron-left",
        next: "fas fa-chevron-right",
      },
    });
  }
});

$(document).on("click", ".salary-sheet-actions-button", (e) => {
  $(".approved-or-rejected-toggle").bootstrapToggle({
    on: "Approve",
    off: "Reject",
    width: "100%",
    size: "small",
    height: "match-parent",
    style: "rounded",
    onstyle: "success",
    offstyle: "danger",
  });
});

$(document).on("change", ".pf-pay-toggle", (e) => {
  let employee_id = e.target
    .closest(".clear-employee-row")
    .getAttribute("employee_id");
  if ($(e.target).prop("checked")) {
    $(e.target).val("1");
    $(`#employee-${employee_id}-pf-note`).attr("readonly", false);
    $(`#employee-${employee_id}-pf-note`).attr("required", true);
  } else {
    $(e.target).val("0");
    $(`#employee-${employee_id}-pf-note`).attr("readonly", true);
    $(`#employee-${employee_id}-pf-note`).attr("required", false);
  }
});

$(document).on("click", "#clear-employees-btn", (e) => {
  $.ajax({
    type: 'GET',
    url: 'employees/new',
    data: { final_settlement_ids: [...selectedRows], operation: 'clear-employees' },
    success(response) {
      $('#clear-multiple-employees').html(response);
      $('#clear-multiple-employees').modal('show');
      initializePfPayToggle();
    },
  });
});

$(document).on('click', '#add-review-for-multiple-final-settlements-btn', (e) => {
  $.ajax({
    type: 'GET',
    url: 'employees/new',
    data: { final_settlement_ids: [...selectedRows], operation: 'add-review' },
    success(response) {
      $('#add-review-on-multiple-final-settlements').html(response);
      $('#add-review-on-multiple-final-settlements').modal('show');
      initializeReviewStatusToggle();
      $('.review-status-toggle').bootstrapToggle('on');
    }
  });
});

$(document).on('click', '#manually-pay-multiple-final-settlements-btn', (e) => {
  $.ajax({
    type: 'GET',
    url: 'employees/new',
    data: { final_settlement_ids: [...selectedRows], operation: 'pay-manually' },
    success(response) {
      $('#manually-pay-multiple-employees').html(response);
      $('#manually-pay-multiple-employees').modal('show');
      initializeBulkManualPaymentToggle();
    }
  });
});

$(document).on('change', '.payment-toggle', (e) => {
  const toggle = $(e.currentTarget);
  const employeeId = toggle.attr('id').split('-')[1];
  const amountField = $(`#employee-${employeeId}-amount`);
  let payableAmount = $(`#employee-${employeeId}-payable-amount`).val();

  if (payableAmount.startsWith('-')) {
    payableAmount = payableAmount.substring(1);
  }

  if (toggle.prop('checked')) {
    amountField.val(payableAmount).prop('readonly', true);
  } else {
    amountField.prop('readonly', false);
  }
});

$(document).on('change', '.review-status-toggle', (e) => {
  let employeeId = e.target.closest('.final-settlement-add-review-row').getAttribute('employee_id');
  let toggle = $(`#employee-${employeeId}-review-status`);

  if (toggle.prop('checked')) {
    toggle.val(1);
    $(`#employee-${employeeId}-remarks`).attr('required', false);
  }
  else {
    toggle.val(0);
    $(`#employee-${employeeId}-remarks`).attr('required', true);
  }
});

$(document).on('click', '#clear-employee-btn', () => { initializePfPayToggle(); });

$(document).on('click', '.js-final-settlement-sheet-modal', (e) => {
  e.preventDefault();
  e.stopPropagation();

  const button = $(e.currentTarget);
  const finalSettlementId = button.data('employee-salary-id');
  const modalType = button.data('modal-type');
  const originalHtml = button.html();

  button.prop('disabled', true);
  button.html('<i class="fa fa-spinner fa-spin"></i> Loading...');

  $.ajax({
    type: 'GET',
    url: `/final_settlements/${finalSettlementId}/salary_sheet_action_modal`,
    dataType: 'json',
    data: { modal_type: modalType },
    success(response) {
      const modal = $(response.html);
      $(`#${modal.attr('id')}`).remove();
      $('body').append(modal);
      initializeFinalSettlementActionModal(modalType);
      modal.modal('show');
    },
    error() {
      redirectToFinalSettlements();
    },
    complete() {
      button.prop('disabled', false);
      button.html(originalHtml);
    }
  });
});

$(document).on('hidden.bs.modal', '.lazy-salary-sheet-modal', function () {
  $(this).remove();
});

$(document).on('ajax:error ajax:success', '#clear-employees-form, #multiple-reviews-form, #manually-pay-multiple-employees-form', (e) => {
  if (window.location.pathname == '/final_settlements') {
    $('#add-review-on-multiple-final-settlements').modal('hide');
    redirectToFinalSettlements();
  }
});

$(document).on("change", "#final-settlement-salary-month", (e) => {
  renderFinalSettlementSheet();
  let currentSalaryMonthYear = $("#final-settlement-sheet-actions").attr(
    "salary-month-year"
  );
  let selectedValue = $(e.target).find("option:selected").text();
  const visibility =
    currentSalaryMonthYear === selectedValue ? "visible" : "hidden";

  $("#generate-final-settlement-sheet-btn")[0].style.visibility = visibility;
  $("#final-settlement-sheet-actions")[0].style.visibility = visibility;
});

$(document).on(
  "change",
  "#select-legends-final-settlement-sheet, #final-settlement-status-filter, #select-business-unit-filter, #select-currency-filter, #select-convert-to-currency",
  (e) => {
    window.location.pathname == "/final_settlements" &&
      renderFinalSettlementSheet();
  }
);

$(document).on("click", "#final-settlement-sheet-column", (e) => {
  if ($(".modal").css("display") == "block") {
    return;
  }
  $(".side-pane").addClass("display-center");
  $(".side-pane").css("width", "85%");
  $(".side-pane-layer").css("display", "block");
  $("body").css("overflow", "hidden");
  $.ajax({
    type: "GET",
    url: `/final_settlements/${$(e.target.parentElement).attr(
      "data-emp-salary-id"
    )}`,
    dataType: "JSON",
    data: { convert_to: $("#select-convert-to-currency").val() },
    success(response) {
      $(".side-pane").removeClass("display-center");
      $(".side-pane").html(response.html);
      document.querySelectorAll(".nav-tabs").forEach((e) => {
        e.firstChild.classList.add("active");
      });
      document.querySelectorAll(".tab-content").forEach((e) => {
        e.firstChild.classList.add("show", "active");
      });
    },
  });
});

$(document).on("click", "#generate-final-settlement-sheet-btn", function (e) {
  e.preventDefault();
  const form = $(e.currentTarget).closest("form");
  form[0].requestSubmit();
});

$(document).on("click", "#final-settlement-salary-generation-btn", (e) => {
  e.stopPropagation();
  const button = $(e.currentTarget);
  button.prop("disabled", true);
  const originalHtml = button.html();
  const employeeSalaryId = button.attr("data");

  button.html('<i class="fa fa-spinner fa-spin"></i> Loading...');
  $.ajax({
    type: "PATCH",
    url: `/employee_salaries/operations/generate`,
    data: {
      salary_sheet_type: "final-settlement-sheet",
      salary_entities: "all",
      employee_salary_type: "FinalSettlement",
      employee_salary_ids: [employeeSalaryId],
    },
    success: () => {
      button.html(originalHtml);
      redirectToFinalSettlements();
    },
    error: () => {
      button.html(originalHtml);
      redirectToFinalSettlements();
    },
  });
});

$(document).on("click", "#final-settlement-salary-reveiwal-btn", (e) => {
  e.stopPropagation();
  let employeeSalaryId = $(e.target).closest(".dropdown-menu").attr("data");
  $.ajax({
    type: "PATCH",
    url: "/employee_salaries/operations/ready_for_review",
    data: {
      employee_salary_type: "FinalSettlement",
      employee_salary_ids: [employeeSalaryId],
    },
    success: () => redirectToFinalSettlements(),
    error: () => redirectToFinalSettlements(),
  });
});

$(document).on('click', '#final-settlement-salary-unlock-btn', (e) => {
  e.stopPropagation();
  if (!confirm('Are you sure you want to unlock this final settlement?')) { return; }
  let employeeSalaryId = $(e.target).closest('.dropdown-menu').attr('data');
  $.ajax({
    type: 'DELETE',
    url: `/salary_approvals/${employeeSalaryId}`,
    success: () => redirectToFinalSettlements(),
    error: () => redirectToFinalSettlements()
  });
});

$(document).on("ajax:error ajax:success", ".add-review-form", (e) => {
  if (window.location.pathname == "/final_settlements") {
    redirectToFinalSettlements();
  }
});

$(document).on('click', '#select_all', function () {
  const selectAll = $(this);
  const isChecked = selectAll.prop('checked');
  const visibleCheckboxes = $('.select_row:not(.d-none)');

  visibleCheckboxes.prop('checked', isChecked);

  if (isChecked) {
    visibleCheckboxes.each(function () { selectedRows.add($(this).val()); });
  } else {
    $(".select_row").removeClass("d-none");
    selectedRows.clear();
  }

  hideOrShowActionButtons();
});

$(document).on("click", ".select_row", function () {
  let rowValue = $(this).val();
  if (this.checked) {
    selectedRows.add(rowValue);
  } else {
    selectedRows.delete(rowValue);
  }

  hideOrShowCheckboxes();
  hideOrShowActionButtons();
  handleSelectAllToggle();
});

$(document).on("draw.dt", "#final-settlement-sheet", function () {
  handleSelectAllToggle();
  hideOrShowActionButtons();
})

$(document).on(
  "click",
  "#finalize-multiple-final-settlements-btn, #generate-multiple-final-settlement-btn",
  function (e) {
    e.stopPropagation();
    const $btn = $(this);
    const actionsRoot = $("#final-settlement-sheet-actions");
    const actionsToggle = actionsRoot.find(".dropdown-toggle");
    const actionMenuButtons = actionsRoot.find(".dropdown-menu button");
    const isGenerateAction =
      $btn.attr("id") === "generate-multiple-final-settlement-btn";
    const executeRequest = () => {
      actionMenuButtons.prop("disabled", true);
      $btn.html('<i class="fa fa-spinner fa-spin"></i> Loading...');
      actionsToggle.prop("disabled", false);
      keepSalaryOperationsDropdownOpen(actionsRoot);
      const url = isGenerateAction
        ? "/employee_salaries/operations/generate"
        : "/employee_salaries/operations/ready_for_review";
      const data = {
        employee_salary_type: "FinalSettlement",
        salary_sheet_type: "final-settlement-sheet",
        employee_salary_ids: [...selectedRows],
      };

      $.ajax({
        type: "PATCH",
        url: url,
        data: data,
        success: () => redirectToFinalSettlements(),
        error: () => redirectToFinalSettlements(),
      });
    };

    executeRequest();
  }
);

const keepSalaryOperationsDropdownOpen = (actionsRoot) => {
  const toggle = actionsRoot.find(".dropdown-toggle");
  const menu = actionsRoot.find(".dropdown-menu");

  const reopen = () => {
    actionsRoot.addClass("show");
    menu.addClass("show");
    toggle.attr("aria-expanded", "true");
  };

  reopen();
  setTimeout(reopen, 0);
  setTimeout(reopen, 150);
};

$(document).on('click', '#unlock-multiple-final-settlements-btn', function (e) {
  e.stopPropagation();
  if (!confirm('Are you sure you want to unlock selected final settlements?')) { return; }

  let btn = $(this);
  const selectedIds = [...selectedRows];
  if (!selectedIds.length) { return; }

  $('#final-settlement-sheet-actions button').prop('disabled', true);
  btn.html('<i class="fa fa-spinner fa-spin"></i> Loading...');

  const requests = selectedIds.map((id) => $.ajax({ type: 'DELETE', url: `/salary_approvals/${id}` }));
  $.when.apply($, requests).always(() => redirectToFinalSettlements());
});

const renderFinalSettlementSheet = () => {
  $("#final-settlement-sheet").DataTable().clear().destroy();
  $("#final-settlement-sheet").DataTable({
    lengthMenu: [
      [10, 50, 100, 500],
      [10, 50, 100, 500],
    ],
    pageLength: 50,
    bDestroy: true,
    fixedHeader: true,
    processing: true,
    serverSide: true,
    ajax: {
      'type': 'GET',
      'url': '/final_settlements',
      'dataType': 'json',
      'data': (data) => {
        data.page = parseInt($('#final-settlement-sheet').DataTable().page.info().page) + 1
        data.per_page = $('#final-settlement-sheet').DataTable().page.info().length
        data.search = {
          text: data.search.value,
          filters: $('#select-legends-final-settlement-sheet').val(),
          status: $('#final-settlement-status-filter').val(),
          currency: $('#select-currency-filter').val(),
          convert_to: $('#select-convert-to-currency').val()
        }
        data.order = $('#final-settlement-sheet').DataTable().order()[0][0]
        data.direction = $('#final-settlement-sheet').DataTable().order()[0][1]
        data.month_year = $("#final-settlement-salary-month").find("option:selected").text();
      }
    },
    "drawCallback": () => {
      if ($('#final-settlement-sheet').DataTable().rows().count()) {
        $('#final-settlement-sheet tr:last').attr('id', 'net-total-row');
      }
      hideOrShowCheckboxes();
      hideOrShowActionButtons();
      handleSelectAllToggle();
    },
    deferRender: true,
    columnDefs: [
      {
        targets: 0,
        bSortable: false,
        createdCell: (td, cellData, rowData, row, col) => {
          $(td).addClass("text-center");
          if (
            rowData[20] &&
            $.inArray(rowData[20].status, ["cleared", "inactive"]) == -1 &&
            rowData[20].salary_id === rowData[20].current_salary_id
          ) {
            $(td).append(
              `<input type="checkbox" class="select_row" value="${
                rowData[20].emp_salary_id
              }" ${
                selectedRows.has(`${rowData[20].emp_salary_id}`)
                  ? "checked"
                  : ""
              } >`
            );
          }
        },
      },
      {
        targets: 1,
        createdCell: (td, cellData, rowData, row, col) => {
          $(td).addClass("text-center");

          if (rowData[20] && rowData[20].approved) {
            $(td).append(
              "<i class='fas fa-sm fa-lock px-2 d-block text-center'></i>"
            );
          }
        },
      },
      {
        targets: 2,
        createdCell: (td, cellData, rowData, row, col) => {
          if (rowData[20]) {
            table_row = $(td).closest("tr");
            table_column = $(td);
            table_row.addClass(rowData[20].row_color_code);
            table_column.addClass("employee-profile-page text-break");
            table_row.addClass("cursor-pointer");
            table_row.addClass("final-settlement-row");
            table_row.attr("data-emp-salary-id", rowData[20].emp_salary_id);
            table_row.attr("data-status", rowData[20].status);
            table_column.attr(
              "onClick",
              `window.open('/employees/${rowData[20].employee_external_id}')`
            ),
              table_column.attr({
                "data-toggle": "tooltip",
                "data-placement": "right",
                title: `${rowData[20].employee_designation}`,
              });
          }
        },
      },
      {
        targets: [
          ...Array(
            $("#final-settlement-sheet").DataTable().columns().count() - 2
          ).keys(),
        ].slice(3),
        createdCell: (td, cellData, rowData, row, col) => {
          $(td).attr("id", "final-settlement-sheet-column");
          const updatedAfterLockColumns = (rowData[20]?.entities_updated_after_lock || [])
            .flatMap((entity) => UPDATED_AFTER_LOCK_ENTITY_COLUMNS[entity] || []);
          if (
            rowData[20] &&
            updatedAfterLockColumns.includes(col)
          ) {
            $(td).addClass("bg-light-orange");
          }
        },
      },
      {
        targets: -1,
        bSortable: false,
      },
    ],
    rowCallback: (row, data, dataIndex) => {
      $(row)
        .find(".salary-sheet-actions-dropdown")
        .closest("td")
        .addClass("disable-propagation");
    },
  });
  debounceSearch("#final-settlement-sheet");
};

const redirectToFinalSettlements = () => {
  window.location.href = "/final_settlements";
};

const initializeFinalSettlementActionModal = (modalType) => {
  switch (modalType) {
    case 'manual_payment':
      initializeManualPaymentModalToggle();
      break;
    case 'review':
      initializeReviewStatusToggle();
      $('.review-status-toggle').bootstrapToggle('on');
      break;
    case 'clear_employee':
      initializePfPayToggle();
      break;
  }
};

const handleSelectAllToggle = () => {
  const tableBody = $("#final-settlement-table-body")[0];
  const selectAllCheckbox = document.querySelector(
    "#final-settlement-table-header #select_all"
  );

  if (!tableBody || !selectAllCheckbox) return;

  const visibleCheckboxes = tableBody.querySelectorAll(
    ".select_row:not(.d-none)"
  );
  const checkedCount = Array.from(visibleCheckboxes).filter(
    (cb) => cb.checked
  ).length;

  selectAllCheckbox.checked =
    visibleCheckboxes.length > 0 && checkedCount === visibleCheckboxes.length;
};

const hideOrShowActionButtons = () => {
  const elements = {
    generateSheet: $('#generate-final-settlement-sheet')[0],
    sheetActions: $('#final-settlement-sheet-actions')[0],
    clearEmployeesBtn: $('#clear-employees-btn')[0],
    generateMultipleBtn: $('#generate-multiple-final-settlement-btn')[0],
    finalizeMultipleBtn: $('#finalize-multiple-final-settlements-btn')[0],
    addReviewMultipleBtn: $('#add-review-for-multiple-final-settlements-btn')[0],
    unlockMultipleBtn: $('#unlock-multiple-final-settlements-btn')[0],
    payMultipleBtn: $('#manually-pay-multiple-final-settlements-btn')[0]
  };

  const checkedRows = document.querySelectorAll(
    "#final-settlement-table-body .select_row:checked"
  );
  const statuses = Array.from(checkedRows).map(
    (row) => row.closest(".final-settlement-row")?.dataset.status
  );

  if (statuses.some((s) => ["cleared", "inactive"].includes(s))) {
    return;
  }

  elements.generateSheet?.classList.toggle("d-none", checkedRows.length > 0);
  elements.sheetActions?.classList.toggle("d-none", checkedRows.length === 0);

  if (checkedRows.length > 0) {
    const statusConfig = {
      locked: {
        clearEmployees: true,
        generateMultiple: false,
        finalizeMultiple: false,
        addReviewMultiple: false,
        unlockMultiple: true,
        payMultiple: true
      },
      ready_for_review: {
        clearEmployees: false,
        generateMultiple: true,
        finalizeMultiple: false,
        addReviewMultiple: true,
        unlockMultiple: false,
        payMultiple: false
      },
      active: {
        clearEmployees: false,
        generateMultiple: true,
        finalizeMultiple: true,
        addReviewMultiple: false,
        unlockMultiple: false,
        payMultiple: false
      }
    };

    const currentStatus = ["locked", "ready_for_review", "active"].find(
      (status) => statuses.includes(status)
    );

    if (currentStatus) {
      const config = statusConfig[currentStatus];
      elements.clearEmployeesBtn?.classList.toggle('d-none', !config.clearEmployees);
      elements.generateMultipleBtn?.classList.toggle('d-none', !config.generateMultiple);
      elements.finalizeMultipleBtn?.classList.toggle('d-none', !config.finalizeMultiple);
      elements.addReviewMultipleBtn?.classList.toggle('d-none', !config.addReviewMultiple);
      elements.unlockMultipleBtn?.classList.toggle('d-none', !config.unlockMultiple);
      elements.payMultipleBtn?.classList.toggle('d-none', !config.payMultiple);
    }
  }
};

const initializePfPayToggle = () => {
  $(".pf-pay-toggle").bootstrapToggle({
    on: "With PF",
    off: "Without PF",
    width: "50%",
    size: "small",
    height: "match-parent",
    style: "rounded",
  });
};

const initializeReviewStatusToggle = () => {
  $('.review-status-toggle').bootstrapToggle({
    on: 'Approve',
    off: 'Reject',
    width: '100%',
    size: 'small',
    height: 'match-parent',
    style: 'rounded',
    onstyle: 'success',
    offstyle: 'danger'
  });
};

const initializeBulkManualPaymentToggle = () => {
  $('.payment-toggle').bootstrapToggle({
    on: 'Complete',
    off: 'Partial',
    width: '100%',
    size: 'small',
    height: 'match-parent',
    style: 'rounded',
    onstyle: 'success'
  });
};

const initializeManualPaymentModalToggle = () => {
  $('.manual-payment-toggle').bootstrapToggle({
    on: 'Complete Amount',
    off: 'Partial Amount',
    width: '50%',
    size: 'small',
    height: 'match-parent',
    style: 'rounded'
  });
};

const hideOrShowCheckboxes = () => {
  const checkedRows = document.querySelectorAll(
    "#final-settlement-table-body .select_row:checked"
  );
  const statuses = [
    ...new Set(
      Array.from(checkedRows).map(
        (checkbox) => checkbox.closest(".final-settlement-row")?.dataset.status
      )
    ),
  ];

  document.querySelectorAll(".select_row").forEach((checkbox) => {
    const rowStatus = checkbox.closest("tr")?.dataset.status;
    checkbox.classList.toggle(
      "d-none",
      checkedRows.length > 0 && !statuses.includes(rowStatus)
    );
  });
};
